export default {
  voyager: {
    url: 'https://api.maptiler.com/maps/basic/{z}/{x}/{y}.png?key={key}',
    opts: {
      tileSize: 512,
      zoomOffset: -1,
      minZoom: 1,
      attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">© MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>',
      crossOrigin: true,
      key: 'GrA386caOO3aJTmYVQby'
    }
  },
  dark: {
    url: 'https://api.maptiler.com/maps/darkmatter/{z}/{x}/{y}.png?key={key}',
    opts: {
      tileSize: 512,
      zoomOffset: -1,
      minZoom: 1,
      attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">© MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>',
      crossOrigin: true,
      key: 'GrA386caOO3aJTmYVQby'
    }
  },
  light: {
    url: 'https://api.maptiler.com/maps/positron/{z}/{x}/{y}.png?key={key}',
    opts: {
      tileSize: 512,
      zoomOffset: -1,
      minZoom: 1,
      attribution: '<a href="https://www.maptiler.com/copyright/" target="_blank">© MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>',
      crossOrigin: true,
      key: 'GrA386caOO3aJTmYVQby'
    }
  }
}
